 import { createUnifiedTheme, genPageTheme, palettes, shapes } from '@backstage/theme';

// Dark blue brand color for the banner/header bar
const DARK_BLUE = '#002D72';
// Light blue for buttons and links (better contrast)
const LIGHT_BLUE = '#1E88E5';

export const geniusTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: {
      main: LIGHT_BLUE,
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#64B5F6',
      contrastText: '#ffffff',
    },
    link: LIGHT_BLUE,
    linkHover: '#2196F3',
    banner: {
      ...palettes.light.banner,
      link: LIGHT_BLUE,
    },
    tabbar: {
      indicator: LIGHT_BLUE,
    },
  },
  pageTheme: {
    // Override banner colors to dark blue for all page themes
    home: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    documentation: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    tool: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    service: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    website: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    library: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    app: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    other: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: LIGHT_BLUE,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        // Primary variants styling
        root: {
          // Filled primary variant
          '&.MuiChip-filled.MuiChip-colorPrimary': {
            backgroundColor: LIGHT_BLUE,
            color: '#ffffff',
          },
          // Outlined primary variant border/text color
          '&.MuiChip-outlined.MuiChip-colorPrimary': {
            borderColor: LIGHT_BLUE,
            color: LIGHT_BLUE,
          },
          // When deletable + primary, keep focus background consistent
          '&.MuiChip-deletable.MuiChip-colorPrimary': {
            '&:focus': {
              backgroundColor: LIGHT_BLUE,
            },
          },
        },
        // Target the delete icon only when in primary color state
        deleteIcon: {
          '.MuiChip-colorPrimary &': {
            color: '#ffffff',
            '&:hover': { color: '#ffffff' },
          },
        },
      },
    },
  },
});

export const geniusDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: LIGHT_BLUE,
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#64B5F6',
      contrastText: '#ffffff',
    },
    link: '#82BAFD',
    linkHover: '#9CC9FF',
    banner: {
      ...palettes.dark.banner,
      link: '#82BAFD',
    },
    tabbar: {
      indicator: LIGHT_BLUE,
    },
  },
  pageTheme: {
    // Keep consistent brand banner color in dark mode as well
    home: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    documentation: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    tool: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    service: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    website: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    library: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    app: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
    other: genPageTheme({ colors: [DARK_BLUE, DARK_BLUE], shape: shapes.wave }),
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: LIGHT_BLUE,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        // Primary variants styling
        root: {
          // Filled primary variant
          '&.MuiChip-filled.MuiChip-colorPrimary': {
            backgroundColor: LIGHT_BLUE,
            color: '#ffffff',
          },
          // Outlined primary variant border/text color
          '&.MuiChip-outlined.MuiChip-colorPrimary': {
            borderColor: LIGHT_BLUE,
            color: LIGHT_BLUE,
          },
          '&.MuiChip-deletable.MuiChip-colorPrimary': {
            '&:focus': {
              backgroundColor: LIGHT_BLUE,
            },
          },
        },
        deleteIcon: {
          '.MuiChip-colorPrimary &': {
            color: '#ffffff',
            '&:hover': { color: '#ffffff' },
          },
        },
      },
    },
  },
});
